export default {
  ADD: 1,
  REMOVE: 2,
  MOVE: 3,
  DONATED: 4,
  DONATION_RECEIVED: 5,
  INCOMING_ORDER: 6,
  OUTGOING_ORDER: 7,
  SCHEDULE: 8,
  ORDER_SHIPPED: 9,
  ORDER_RECEIVED: 10,
  DAMAGED: 11,
  SPOILED: 12,
  LOST: 13,
  EXPIRED: 14,
  STOLEN: 15,
  VISIT: 16,
  FOUND_NEW: 17,
  ADD_CORRECTION: 18,
  REMOVE_CORRECTION: 19,
  PURCHASED: 20,
  SOLD: 21,
  DISTRIBUTION_RECEIVED: 22,
  DISTRIBUTED: 23,
  POS_ADD: 24,
  POS_DEDUCT: 25,
  POS_CANCELED: 26,
  DONATION_REMOVED: 27
};
